/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 17,
        viewBox: "0 0 18 17",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M4.6 3.46V2.7c0-.43.35-.78.78-.78h1.05c.44 0 .79.35.79.78v.71q.72.24 1.29.71l.6-.34a.8.8 0 0 1 1.08.28l.52.9c.22.37.1.84-.29 1.06l-.58.33a4 4 0 0 1 0 1.49l.58.33c.38.21.51.69.3 1.06l-.53.9a.8.8 0 0 1-1.08.28l-.6-.35q-.57.48-1.29.71v.71c0 .43-.35.78-.79.78H5.38a.8.8 0 0 1-.78-.78v-.76q-.68-.25-1.2-.7l-.7.39a.8.8 0 0 1-1.07-.29l-.52-.9a.77.77 0 0 1 .28-1.05l.72-.4a4 4 0 0 1 0-1.35l-.72-.4a.77.77 0 0 1-.28-1.06l.52-.9a.8.8 0 0 1 1.08-.28l.69.4q.52-.46 1.2-.72",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M5.9 8.38a1.3 1.3 0 1 0 0-2.58 1.3 1.3 0 0 0 0 2.58",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M6.94 14.86c1.33.6 2.79.52 2.79.52 1.36 0 2.64-.38 3.74-1.03.27-.17 2.76 1.22 3.28.7.51-.52-.95-2.94-.8-3.17A7.28 7.28 0 0 0 11.28 1",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
